import axios from "../common/http-common";


//const API_URL = ""

class AuthService {

    login(userdata) {
        //console.log('login');
        //console.log(userdata);
        return axios.post("/auth/signin", userdata)
            .then(response => {
                if (response.data.accessToken) {
                    localStorage.setItem("user", JSON.stringify(response.data));
                   // console.log(axios);
                }

                return response.data;
            });
    }

   

    logout() {
        localStorage.removeItem("user");
    }


    getCurrentUser() {
        return JSON.parse(localStorage.getItem('user'));
    }
}

export default new AuthService();